import * as effects from 'redux-saga/effects';
import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';
import {
	addACLResource,
	addResourceFailed,
	addResourceSucceed,
	getACLResources,
	getACLResourcesFailed,
	getACLResourcesParents,
	getACLResourcesParentsFailed,
	getACLResourcesParentsSucceed,
	getACLResourcesSucceed,
	getACLResourcesTypes,
	getACLResourcesTypesFailed,
	getACLResourcesTypesSucceed,
	emptyListACLResources,
	deleteACLResource,
	getACLResourceSucceed,
	getACLResourceFailed,
	getACLResource,
	updateACLResource,
	deleteACLResourceSucceed,
	deleteACLResourceFailed,
	updateACLResourceSucceed,
	updateACLResourceFailed,
} from './Actions';
import { IResourcesManagementActionTypes } from './Types';
import { setError, setSuccessMessage } from '../NotificationBar/Actions';

function* handleCreateResource(action: ReturnType<typeof addACLResource>) {
	const backend = Backend.getInstance();

	try {
		// Retirons temporairement le setCreatingResource
		// yield effects.put(setCreatingResource(true));
		
		yield effects.apply(backend, backend.createResource, [
			action.payload[0],
			action.payload[1],
			action.payload[2],
			action.payload[3],
			action.payload[4],
		] as any);

		yield effects.put(addResourceSucceed());
		yield effects.put(setSuccessMessage('Resource created successfully'));
	} catch (err) {
		yield effects.put(addResourceFailed('error while creating resource'));
		yield effects.put(setError(new Error('Failed to create resource')));
		Logger.warn({ err }, 'Failed creating resource');
	} finally {
		// yield effects.put(setCreatingResource(false));
	}
}

function* handleGetACLResource(action: ReturnType<typeof getACLResource>) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getACLResource, [
			action.payload[0],
			action.payload[1],
		] as any);
		yield effects.put(getACLResourceSucceed(res));
	} catch (err) {
		yield effects.put(
			getACLResourceFailed(
				"Impossible d'afficher la ressource une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting resources');
	}
}

function* handleGetACLResources(action: ReturnType<typeof getACLResources>) {
	const backend = Backend.getInstance();

	yield effects.put(emptyListACLResources());
	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getACLResources, [
			action.payload[0],
		] as any);
		yield effects.put(getACLResourcesSucceed(res));
	} catch (err) {
		yield effects.put(
			getACLResourcesFailed(
				"Impossible d'afficher les éléments une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting resources');
	}
}

function* handleGetACLResourcesParents(
	action: ReturnType<typeof getACLResourcesParents>
) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.getACLResourcesParents,
			[action.payload[0]] as any
		);
		yield effects.put(getACLResourcesParentsSucceed(res));
	} catch (err) {
		yield effects.put(
			getACLResourcesParentsFailed(
				"Impossible d'afficher les éléments une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting resources');
	}
}
function* handleGetACLResourcesTypes(
	action: ReturnType<typeof getACLResourcesTypes>
) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(backend, backend.getACLResourcesTypes, [
			action.payload[0],
		] as any);
		yield effects.put(getACLResourcesTypesSucceed(res));
	} catch (err) {
		yield effects.put(
			getACLResourcesTypesFailed(
				"Impossible d'afficher les éléments une erreur s'est produite"
			)
		);
		Logger.warn({ err }, 'Failed getting resources');
	}
}

function* handleDeleteACLResource(action: ReturnType<typeof deleteACLResource>) {
	const backend = Backend.getInstance();
	const [token, id] = action.payload;

	try {
		yield effects.apply(backend, backend.deleteACLResource, [
			token,
			id,
		] as any);
		
		// Mettre à jour le state en retirant la ressource
		yield effects.put(deleteACLResourceSucceed(id));
		yield effects.put(setSuccessMessage('Resource deleted successfully'));
		
		// Ne plus refaire de requête getACLResources
		// yield effects.put(getACLResources(token));
	} catch (err) {
		yield effects.put(deleteACLResourceFailed('Failed to delete resource'));
		yield effects.put(setError(new Error('Failed to delete resource')));
		Logger.warn({ err }, 'Failed deleting resource');
	}
}

function* handleUpdateACLResource(action: ReturnType<typeof updateACLResource>) {
	const backend = Backend.getInstance();
	const [token, id, resource] = action.payload;

	try {
		yield effects.apply(backend, backend.updateACLResource, [
			token,
			id,
			resource,
		] as any);
		
		// Mettre à jour le state avec la ressource modifiée
		yield effects.put(updateACLResourceSucceed(resource));
		yield effects.put(setSuccessMessage('Resource updated successfully'));
		
		// Ne plus refaire de requête getACLResources
		// yield effects.put(getACLResources(token));
	} catch (err) {
		yield effects.put(updateACLResourceFailed('Failed to update resource'));
		yield effects.put(setError(new Error('Failed to update resource')));
		Logger.warn({ err }, 'Failed updating resource');
	}
}

function* watchCreateResource() {
	yield effects.takeLatest(
		IResourcesManagementActionTypes.ADD_ACL_RESOURCE,
		handleCreateResource
	);
}

function* watchGetACLResource() {
	yield effects.takeLatest(
		IResourcesManagementActionTypes.GET_ACL_RESOURCE,
		handleGetACLResource
	);
}
function* watchGetACLResources() {
	yield effects.takeLatest(
		IResourcesManagementActionTypes.GET_ACL_RESOURCES,
		handleGetACLResources
	);
}

function* watchGetACLResourcesParents() {
	yield effects.takeLatest(
		IResourcesManagementActionTypes.GET_ACL_RESOURCESPARENTS,
		handleGetACLResourcesParents
	);
}
function* watchGetACLResourcesTypes() {
	yield effects.takeLatest(
		IResourcesManagementActionTypes.GET_ACL_RESOURCESTYPES,
		handleGetACLResourcesTypes
	);
}

function* watchDeleteACLResource() {
	yield effects.takeLatest(
		IResourcesManagementActionTypes.DELETE_ACL_RESOURCE,
		handleDeleteACLResource
	);
}

function* watchUpdateACLResource() {
	yield effects.takeLatest(
		IResourcesManagementActionTypes.UPDATE_ACL_RESOURCE,
		handleUpdateACLResource
	);
}

export function* ResourcesManagementSaga(): Generator<
	effects.AllEffect<effects.ForkEffect<void>>,
	void
> {
	yield effects.all([effects.fork(watchCreateResource)]);
	yield effects.all([effects.fork(watchDeleteACLResource)]);
	yield effects.all([effects.fork(watchGetACLResource)]);
	yield effects.all([effects.fork(watchGetACLResources)]);
	yield effects.all([effects.fork(watchGetACLResourcesParents)]);
	yield effects.all([effects.fork(watchGetACLResourcesTypes)]);
	yield effects.all([effects.fork(watchUpdateACLResource)]);
}
